import RestaurantCardSubtitleRow from './subtitleRow';

export default RestaurantCardSubtitleRow;
export { type RestaurantCardSubtitleRowProps } from './subtitleRow';

export { default as RestaurantCardSubtitleRowSkeleton } from './skeleton';
